import { invoke } from '../../shims/forge-bridge';
import { ISSUE_TYPES } from '../../common/Constants';
import { DEFAULT_ISSUE_TYPE_AVAILABILITY, IssueTypeAvailability } from './IssueTypeDetector.types';

type JiraIssueType = {
  id: string;
  name: string;
};

export class IssueTypeDetector {
  private static cache: Map<string, IssueTypeAvailability> = new Map();

  static async detectIssueTypes(projectId: string): Promise<IssueTypeAvailability> {
    if (!projectId) return DEFAULT_ISSUE_TYPE_AVAILABILITY;
    if (this.cache.has(projectId)) {
      const cached = this.cache.get(projectId);
      if (cached) return cached;
    }

    try {
      const response = await invoke('fetchProjectIssueTypes', { projectId });
      const issueTypes = this.normalizeIssueTypes(response);

      const availability: IssueTypeAvailability = {
        hasEpic: issueTypes.some((t) => t.name === ISSUE_TYPES.EPIC),
        hasStory: issueTypes.some((t) => t.name === ISSUE_TYPES.STORY),
        hasTask: issueTypes.some((t) => t.name === ISSUE_TYPES.TASK),
        missingTypes: []
      };

      if (!availability.hasEpic) availability.missingTypes.push(ISSUE_TYPES.EPIC);
      if (!availability.hasStory) availability.missingTypes.push(ISSUE_TYPES.STORY);
      if (!availability.hasTask) availability.missingTypes.push(ISSUE_TYPES.TASK);

      this.cache.set(projectId, availability);
      return availability;
    } catch (error) {
      console.error('Failed to detect issue types:', error);
      return DEFAULT_ISSUE_TYPE_AVAILABILITY;
    }
  }

  static clearCache(projectId?: string): void {
    if (projectId) {
      this.cache.delete(projectId);
    } else {
      this.cache.clear();
    }
  }

  private static normalizeIssueTypes(response: unknown): JiraIssueType[] {
    if (Array.isArray(response)) {
      return response as JiraIssueType[];
    }

    if (response && typeof response === 'object') {
      const values = (response as { values?: JiraIssueType[] }).values;
      if (Array.isArray(values)) return values;
    }

    return [];
  }

}
